﻿<script>
  import { onMount } from "svelte/internal";
  import { dispatchMountEvent } from "./services";
  import moment from "moment";
  import Icon from "./Icons.svelte";
  import jquery from "jquery";

  export let _emitMount;
  export let disabled;
  export let accountId;

  // state
  let modelElement;
  let isLoading = false;
  let requestList = [];
  let errorMessage = "";

  onMount(() => {
    if (_emitMount) {
      dispatchMountEvent();
    }
  });

  // methods
  // get history list
  const getHistoryList = async () => {
    // clear list
    requestList = [];
    errorMessage = "";
    // loading
    isLoading = true;
    try {
      // featch
      let response = await fetch(`/api/requests/request-history/${accountId}`, {
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json"
        }
      });

      if (response.status !== 200) {
        throw "";
      }
      const data = await response.json();
      requestList = data.requests;
    } catch (error) {
      errorMessage = "Oops! Something went wrong!";
    }

    // hide loading
    isLoading = false;
    // open modal
    jquery(modelElement).modal("show");
  };

  const clickHandle = () => {
    getHistoryList();
  };
</script>

<button id="requestHistoryBtn"
  type="button"
  class="btn btn-outline-primary btn-lg btn-icon-start {isLoading ? 'is-loading' : ''}"
  {disabled}
  on:click|preventDefault={clickHandle}>

  <Icon icon="RequestHistory" class="icon icon-sm" />
  Requests History
</button>

<!-- MODALS -->
<!-- Request History -->
<div
  class="modal fade"
  bind:this={modelElement}
  tabindex="-1"
  role="dialog"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">History for account {accountId}</h4>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close">

          <Icon icon="X" class="icon" />
        </button>
      </div>
      <div class="modal-body p-0">

        <table class="table table-striped table-sm table-flat">
          <thead>
            <tr>
              <th>Date Raised</th>
              <th>Request Type</th>
              <th>Enquiry Type</th>
              <th>Status</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {#if errorMessage.length}
              <td colspan="100">
                <div class="text-center font-italic">{errorMessage}</div>
              </td>
            {/if}

            {#if requestList.length}
              {#each requestList as request}
                <tr>
                  <td class="font-weight-medium">
                    {moment(request.dateRaised).format('DD/MM/YYYY')}
                  </td>
                  <td>{request.requestType}</td>
                  <td>{request.enquiryType}</td>
                  <td>
                    {#if request.status == 'Closed'}
                      <div class="table-status table-status--disabled">
                        {request.status}
                      </div>
                    {:else if request.status == 'Cancelled'}
                      <div class="table-status table-status--danger">
                        {request.status}
                      </div>
                    {:else if request.status == 'New'}
                      <div class="table-status table-status--info">
                        {request.status}
                      </div>
                    {:else if request.status == 'Active'}
                      <div class="table-status table-status--success">
                        {request.status}
                      </div>
                    {/if}
                  </td>
                  <td>
                    <div class="d-flex justify-content-end text-nowrap">
                      <a
                        href={request.detailsUrl}
                        target="_blank"
                        class="btn-icon-end medium link-decoration-none">
                        <span class="text-dark font-weight-medium">View</span>
                        <Icon icon="Share" class="icon icon-sm ml-2" />
                      </a>
                    </div>
                  </td>
                </tr>
              {/each}
              {:else}
              <td colspan="100">
                <div class="text-center font-italic">No records available</div>
              </td>
            {/if}
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
